import React, { useEffect, useState } from "react";
import "./Certificate.css";
import banner from "../Images/about-banner.jpeg"; 
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import { FaSearchPlus, FaSearchMinus, FaShareAlt, FaDownload, FaTimes } from "react-icons/fa";

import cert1 from "../Images/certificate1.webp";
import cert2 from "../Images/certificate2.webp";
import cert3 from "../Images/certificate3.webp";

const Certificate = () => {
  const certificates = [
    { src: cert1, title: "12A & 80G" },
    { src: cert2, title: "FCRA Registration" },
    { src: cert3, title: "GOSASCCT" }
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [fullscreen, setFullscreen] = useState(false);


       const [bannerImage, setBannerImage] = useState(""); // Store banner image URL
    
      useEffect(() => {
        // Fetch banner data from API
        fetch("https://api.garudasena.org/api/banners")
          .then((response) => response.json())
          .then((data) => {
            // Find the banner for the "About Us" section
            const aboutUsBanner = data.find((banner) => banner.section === "About Us");
            if (aboutUsBanner) {
              setBannerImage(aboutUsBanner.image); // Set the banner image URL
            }
          })
          .catch((error) => console.error("Error fetching banner data:", error));
      }, []);
      

  const openModal = (index) => {
    setCurrentIndex(index);
    setZoom(1);
    setFullscreen(false);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const nextImage = () => setCurrentIndex((currentIndex + 1) % certificates.length);
  const prevImage = () => setCurrentIndex((currentIndex - 1 + certificates.length) % certificates.length);

  const zoomIn = () => setZoom(zoom + 0.2);
  const zoomOut = () => setZoom(Math.max(0.5, zoom - 0.2));

  const toggleFullscreen = () => setFullscreen(!fullscreen);

  const downloadImage = () => {
    const link = document.createElement("a");
    link.href = certificates[currentIndex].src;
    link.download = certificates[currentIndex].title;
    link.click();
  };

  const shareImage = () => {
    const url = window.location.href;
    window.open(`https://www.addtoany.com/share#url=${encodeURIComponent(url)}`, "_blank", "width=600,height=600");
  };

  return (
    <>
      <Navbar />
      <div className="certificate-page">
        <section className="certificate-banner">
          <img src={bannerImage} alt="Certificates" className="banner-image" />
          <div className="banner-overlay">
            <h1>Certificates</h1>
            <p>Recognition of Trust & Compliance</p>
          </div>
        </section>

        <section className="certificate-section">
          <div className="certificate-grid">
            {certificates.map((cert, idx) => (
              <img
                key={idx}
                src={cert.src}
                alt={cert.title}
                // onClick={() => openModal(idx)}
              />
            ))}
          </div>
        </section>

        {modalOpen && (
          <div className="modal-overlay">
            <div className={`modal-image-container ${fullscreen ? "fullscreen" : ""}`}>
              <img
                src={certificates[currentIndex].src}
                alt={certificates[currentIndex].title}
                style={{ transform: `scale(${zoom})` }}
              />
            </div>

            {/* Navigation Arrows */}
            <button className="arrow-left" onClick={prevImage}>‹</button>
            <button className="arrow-right" onClick={nextImage}>›</button>

            {/* Top-right buttons */}
         <div className="modal-buttons">
  {/* Zoom In */}
  <button onClick={zoomIn}><FaSearchPlus /></button>

  {/* Zoom Out */}
  <button onClick={zoomOut}><FaSearchMinus /></button>

  {/* Share */}
  <button onClick={shareImage}><FaShareAlt /></button>

  {/* Download */}
  <button onClick={downloadImage}><FaDownload /></button>

  {/* Close */}
  <button onClick={closeModal}><FaTimes /></button>
</div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Certificate;
